import React, {useMemo} from "react";
import {PAYMENT_TYPE, VDS_LEVEL, VRI_LEVEL} from "../../../constants";
import PlanSubHeaderDetails from "./PlanSubHeaderDetails";

const PlanHeaderNotes = ({ title, subtitle = null, data, paymentType, onPaymentTypeClick }) => {
    const {  devLevelName, expirationDate, doesNotExpire, apiLicense,
        levelName, nextRenewalLevelName, currentCountOfInspectors, level,
        hasActiveFreeTrial, freeTrialExpirationDate } = data || {};

    const isAC = paymentType === PAYMENT_TYPE.AC;
    const isVRI = paymentType === PAYMENT_TYPE.VRI;
    const isVDS = paymentType === PAYMENT_TYPE.VDS;

    const onClick = () => {
        if (onPaymentTypeClick)
            onPaymentTypeClick();
    };

    const cssClasses = useMemo(() => {
        let classes = '';

        if (isAC)
            classes += ' ac-plan-header-color';
        else if (isVRI)
            classes += ' vri-plan-header-color';
        else if (isVDS)
            classes += ' vds-plan-header-color';

        if (onPaymentTypeClick)
            classes += ' clickable';

        return classes;
    }, [paymentType]);

    const logoImgSrc = useMemo(() => {
        if (isVRI)
            return '../images/videx_logo.png';
        else if (isVDS)
            return '../images/videx-data-store.png';

        return '../images/Videx-Logo.png'; // AC
    }, [paymentType]);

    const AdditionalDetails = useMemo(() => {
        if (isAC) {
            return (
                <PlanSubHeaderDetails levelItemTexts={[
                    `${i18n.payments.plan}: ${devLevelName}`,
                ]} expirationDate={expirationDate}
                   doesNotExpire={doesNotExpire}
                   nextRenewalLevelName={null}/>
            );
        } else if (isVRI) {
            const levelItemTexts = [];
            if (level !== VRI_LEVEL.NONE)
                levelItemTexts.push(`${i18n.payments.level}: ${levelName}`);
            if (currentCountOfInspectors)
                levelItemTexts.push(`${i18n.payments.vri.currentCountOfInspectors}: ${currentCountOfInspectors}`);

            return (
                <PlanSubHeaderDetails levelItemTexts={levelItemTexts} expirationDate={expirationDate}
                                      doesNotExpire={doesNotExpire}
                                      hasActiveFreeTrial={hasActiveFreeTrial}
                                      freeTrialExpirationDate={freeTrialExpirationDate}
                                      nextRenewalLevelName={nextRenewalLevelName}/>
            );
        } else if (isVDS) {
            const levelItemTexts = [];
            if (level !== VDS_LEVEL.NONE)
                levelItemTexts.push(`${i18n.payments.level}: ${levelName}`);
            if (apiLicense)
                levelItemTexts.push(`${i18n.payments.vds.apiLicense}: ${apiLicense}`);

            return (
                <PlanSubHeaderDetails levelItemTexts={levelItemTexts}
                                      expirationDate={expirationDate}
                                      doesNotExpire={doesNotExpire}
                                      hasActiveFreeTrial={hasActiveFreeTrial}
                                      freeTrialExpirationDate={freeTrialExpirationDate}
                                      nextRenewalLevelName={nextRenewalLevelName}/>
            );
        }

        return <></>;
    }, [[paymentType, data]]);

    return (
        <>
            <div className={`plan-header ${cssClasses}`} onClick={onClick}>
                <div className={'flexColumn'}>
                    <div style={{ display: 'flex' }}>
                        <img alt={`videx_logo`}
                             className={'plan-header-img'}
                             src={logoImgSrc}/>
                        <div className={'plan-title-div'}>
                            <div className={`plan-title`}>
                                {title}
                            </div>
                            {
                                subtitle && (
                                    <div className={`plan-subtitle`}>
                                        {subtitle}
                                    </div>
                                )
                            }
                        </div>
                    </div>

                    {AdditionalDetails}
                </div>
            </div>
        </>
    );
};

export default PlanHeaderNotes;